import { BaseApiService } from '@/shared/api/services/base.service';
import type { RenderEffort } from '@/types/render';

interface RenderTokenPriceEntry {
  id: RenderEffort;
  token_price: number;
}

interface RenderTokenPricesResponse {
  data: {
    type: 'render-token-prices';
    id: string;
    attributes: {
      efforts: RenderTokenPriceEntry[];
    };
  };
}

class RenderTokenPricesService extends BaseApiService {
  // Effort token prices are server-owned and demand-tuned: the backend changes
  // them without an app release, so the client must never cache a hardcoded
  // number. Map by `id` (the RenderEffort value), never by array order.
  async getTokenPrices(): Promise<Record<RenderEffort, number>> {
    const response = await this.httpGet<RenderTokenPricesResponse>(
      '/v1/renders/token-prices'
    );

    return response.data.attributes.efforts.reduce(
      (acc, entry) => {
        acc[entry.id] = entry.token_price;
        return acc;
      },
      {} as Record<RenderEffort, number>
    );
  }
}

export const renderTokenPricesService = new RenderTokenPricesService();
